import ReactDOM from 'react-dom';

//components
import SelfSignUpTrial from  '@/components/page/navigationBar/SelfSignUpTrial';



const SelfSignUpTrialPortal = () => {
    const targetContainer = document.getElementById('react-self-sign-up-trial-portal');

    if (targetContainer === null){
        return null;
    } 
    return ReactDOM.createPortal(
        <SelfSignUpTrial 
            createDate = {targetContainer?.getAttribute?.('data-org-create-date') ?? ""}
            orgName = {targetContainer?.getAttribute?.('data-org-name') ?? ""}
            brandColor = { targetContainer?.getAttribute?.('data-brand-color') ?? "#302554"}
        />, targetContainer
    );
};

export default SelfSignUpTrialPortal;